import { EventsActionFilters } from './eventsActionFilters';
import { filter } from 'rxjs/operators';
import { DisplayText } from './displayText';

export class EventsActionFilter {
    term: string;
    value: DisplayText;
    filters: EventsActionFilters[];

    constructor() {
        this.term = null;
        this.value = null;
        this.filters = [];
    }

    addFilterItem(filterAction: EventsActionFilters) {
        const element =  this.filters.find( (e) => JSON.stringify(e) === JSON.stringify(filterAction));
        if (!element) {
            this.filters.push(filterAction);
        }
    }

    removeFilterItem(filterAction: EventsActionFilters) {
        const element =  this.filters.find( (e) => JSON.stringify(e) === JSON.stringify(filterAction));
        if (element) {
            const newElements = this.filters.filter((e) => e !== element);
            this.filters = newElements;
        }
    }

    filtersAreDefault() {
        return (this.filters.length === 0) ? true : false ;
    }
}

